@import '~style-sheet-helpers/core.less';

.rule-deletion-modal {
  padding: 40px;
}

.footer {
  display: flex;
  justify-content: space-between;
}
